// frontend/src/components/admin/modals/ClearTournamentsModal.jsx
import React, { useState } from 'react';
import axios from '../../../config/axios';
import { AlertTriangle, Trash2, Loader } from 'lucide-react';

const ClearTournamentsModal = ({ onClose, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [confirmText, setConfirmText] = useState('');

    const handleClearTournaments = async () => {
        if (confirmText !== 'ELIMINAR') {
            setError('Por favor, escribe "ELIMINAR" para confirmar');
            return;
        }

        try {
            setLoading(true);
            setError('');

            const response = await axios.delete('/admin/tournaments/clear-all');

            if (response.data.success) {
                onSuccess();
            } else {
                setError(response.data.message || 'Error al limpiar torneos');
            }
        } catch (error) {
            setError(error.response?.data?.message || 'Error al conectar con el servidor');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
                <div className="p-6">
                    <div className="flex items-center mb-4 text-red-600">
                        <AlertTriangle className="w-6 h-6 mr-2" />
                        <h3 className="text-lg font-bold">Eliminar todos los torneos</h3>
                    </div>

                    <div className="mb-6">
                        <p className="text-gray-700 mb-4">
                            Esta acción eliminará <span className="font-bold">PERMANENTEMENTE</span> todos los torneos,
                            matches y notificaciones relacionadas de la base de datos.
                        </p>
                        <p className="text-gray-700 mb-4 font-bold">
                            Esta acción no se puede deshacer.
                        </p>

                        <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-4">
                            <p className="text-red-700 text-sm">
                                Escribe "ELIMINAR" en el campo a continuación para confirmar:
                            </p>
                            <input
                                type="text"
                                className="mt-2 w-full border border-gray-300 rounded-md px-3 py-2 text-gray-700"
                                value={confirmText}
                                onChange={(e) => setConfirmText(e.target.value)}
                                placeholder="ELIMINAR"
                            />
                        </div>

                        {error && (
                            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-2 rounded-md mb-4">
                                {error}
                            </div>
                        )}
                    </div>

                    <div className="flex justify-end space-x-3">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300"
                            disabled={loading}
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={handleClearTournaments}
                            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 flex items-center"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <Loader className="w-4 h-4 mr-2 animate-spin" />
                                    Procesando...
                                </>
                            ) : (
                                <>
                                    <Trash2 className="w-4 h-4 mr-2" />
                                    Eliminar todos
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClearTournamentsModal;